
import React, { useState } from 'react';
import { Form as FinalForm, Field } from 'react-final-form';
import {
    Input, Button, Form, Dropdown, Grid, Label
} from 'semantic-ui-react';
import { TextField } from '+/components';
import { useCreateSpecial, useAvailableSpecialGroupings } from '~/groupings';

const styles = {
    root: {
        padding: '15px'
    }
};

const SpecialsForm = props => {

    const { initialValues } = props;

    const [dropdownOptions, setDropdownOptions] = useState([]);
    const { mutate: createGrouping } = useCreateSpecial();
    useAvailableSpecialGroupings(initialValues.property_id, {
        onSuccess: data => {

            const options = createDropdownOptions(
                data.concat(initialValues?.unitTypes || [])
            );

            setDropdownOptions(options);
        }
    });

    const onSubmit = async ({ special_type, ...payload }) => {

        payload.unitTypes = payload.unitTypes.map((i => ({ id: i })));

        if (special_type === 'percent') {
            payload.special = +payload.special / 100;
        }

        if (special_type === 'dollar') {
            payload.special = parseFloat(payload.special).toFixed(0);
        }

        createGrouping(payload);
        props.closeModal();

    };

    return (
        <FinalForm
            initialValues={{
                ...initialValues,
                unitTypes: initialValues.unitTypes?.map(i => i.id) || [],
                ...parseSpecial(initialValues.special)
            }}
            validate={validate}
            onSubmit={onSubmit}
            render={({
                handleSubmit, submitting, pristine, hasValidationErrors, errors
            }) => (
                <div style={styles.root}>
                    <Form onSubmit={handleSubmit}>

                        <TextField name='name' label='Special Name' />

                        <Grid verticalAlign='bottom' padded='vertically'>
                            <Grid.Row>
                                <Grid.Column width='12'>
                                    <Field name='special'>
                                        {({ input, meta }) => (
                                            <Form.Field>
                                                <label htmlFor={'special'}>Discount</label>
                                                <Input step='.01' type='number' min={0} placeholder='Discount' {...input}/>
                                            </Form.Field>
                                        )}
                                    </Field>
                                </Grid.Column>
                                <Grid.Column>
                                    <Field name='special_type'>
                                        {({ input, meta }) => (
                                            <Button.Group toggle>
                                                <Button
                                                    active={input.value === 'dollar'}
                                                    onClick={e => {
                                                        e.preventDefault();
                                                        input.onChange('dollar');
                                                    }}
                                                    content='Dollar'
                                                />
                                                <Button.Or />
                                                <Button
                                                    active={input.value === 'percent'}
                                                    onClick={e => {
                                                        e.preventDefault();
                                                        input.onChange('percent');
                                                    }}
                                                    content='Percentage'
                                                />
                                            </Button.Group>
                                        )}
                                    </Field>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>

                        {hasValidationErrors && errors.special && <Label basic color='red' pointing='above'>{errors.special}</Label>}


                        <Field name='unitTypes'>
                            {({ input, meta }) => (
                                <Form.Field>
                                    <label htmlFor='unitTypes'> Unit Types</label>
                                    <Dropdown
                                        placeholder='Unit Types'
                                        search
                                        noResultsMessage='No Available Unit Types'
                                        fluid
                                        multiple
                                        selection
                                        options={dropdownOptions}
                                        value={input.value}
                                        onChange={(e, { value }) => input.onChange(value)}
                                    />
                                </Form.Field>
                            )}
                        </Field>

                        <Form.Field>
                            <Button negative onClick={props.closeModal}>
                            Cancel
                            </Button>
                            <Button floated='right' type='submit' disabled={submitting || pristine}>
                            Submit
                            </Button>
                        </Form.Field>
                    </Form>
                </div>
            )}
        />
    );
};

const createDropdownOptions = arr => arr.map(item => ({
    text: item.name,
    value: item.id

}));

const isPercent = num => num % 1 !== 0;
const toNum = num => num * 100;

const parseSpecial = special => {
    if (!special) return {};

    if (isPercent(special)) {

        return {
            special: toNum(special),
            special_type: 'percent'
        };
    }

    return {
        special,
        special_type: 'dollar'
    };
};

const validate = values => {
    const errors = {};

    if (values.special && !values.special_type) {
        errors.special = 'You must select either dollar or percentage.';
    }

    if (values.special_type === 'percent' && values.special > 99) {

        errors.special = 'Value must be under 100 if using percentage';
    }

    if (!values.special) {
        errors.special = 'Required';
    }


    return errors;
};

export default SpecialsForm;
